export default __webpack_public_path__ + "static/vedica-0e8d784d296c52dbd9874838a3cedc3b.png";